import { render, staticRenderFns } from "./MainLedgerLLA.vue?vue&type=template&id=0f8d2061"
import script from "./MainLedgerLLA.vue?vue&type=script&lang=js"
export * from "./MainLedgerLLA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports